const tr = {
  app_name: "Netlen Canlı Destek",
  nav: {
    dashboard: "Dashboard",
    inbox: "Gelen Kutusu",
    sites: "Siteler",
    ai: "AI Chatbot",
    analytics: "Analitik",
    settings: "Ayarlar",
    logout: "Çıkış",
  },
  auth: {
    login: "Giriş Yap",
    register: "Kayıt Ol",
    email: "E-posta",
    password: "Şifre",
    name: "Ad Soyad",
    login_title: "Hesabınıza giriş yapın",
    register_title: "Yeni hesap oluşturun",
    no_account: "Hesabınız yok mu?",
    have_account: "Zaten hesabınız var mı?",
    loading: "Yükleniyor...",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Hoş geldiniz",
    total_convs: "Toplam Konuşma",
    open_convs: "Açık Konuşmalar",
    ai_handled: "AI Çözümlü",
    resolved: "Çözümlendi",
    recent_convs: "Son Konuşmalar",
    no_convs: "Henüz konuşma yok",
    view_all: "Tümünü Gör",
    today: "Bugün",
    this_week: "Bu Hafta",
  },
  inbox: {
    title: "Gelen Kutusu",
    all: "Tümü",
    open: "Açık",
    pending: "Bekliyor",
    resolved: "Çözümlendi",
    unassigned: "Atanmamış",
    mine: "Benimkiler",
    search: "Konuşma ara...",
    no_convs: "Konuşma bulunamadı",
    type_message: "Mesaj yazın...",
    send: "Gönder",
    assign_to_me: "Bana Ata",
    resolve: "Çözümle",
    close: "Kapat",
    reopen: "Yeniden Aç",
    visitor_info: "Ziyaretçi Bilgileri",
    quick_replies: "Hızlı Yanıtlar",
    add_note: "Not Ekle",
    internal_note: "Dahili Not",
    tags: "Etiketler",
    pages_visited: "Ziyaret Edilen Sayfalar",
    no_pages: "Sayfa ziyareti yok",
    ai_handled: "AI Chatbot tarafından yanıtlandı",
    agent_handling: "Agent tarafından yanıtlanıyor",
  },
  sites: {
    title: "Siteler",
    add_site: "Site Ekle",
    domain: "Domain",
    name: "Site Adı",
    embed_code: "Embed Kodu",
    copy_code: "Kodu Kopyala",
    copied: "Kopyalandı!",
    widget_settings: "Widget Ayarları",
    primary_color: "Ana Renk",
    position: "Konum",
    right: "Sağ Alt",
    left: "Sol Alt",
    greeting: "Karşılama Mesajı",
    ai_settings: "AI Ayarları",
    enable_ai: "AI Chatbot'u Etkinleştir",
    save: "Kaydet",
    delete: "Sil",
    edit: "Düzenle",
    no_sites: "Henüz site eklenmemiş",
    add_first: "İlk sitenizi ekleyin",
    agents: "Agentlar",
  },
  ai: {
    title: "AI Chatbot",
    knowledge_base: "Bilgi Tabanı",
    add_text: "Metin Ekle",
    add_url: "URL Ekle",
    upload_pdf: "PDF Yükle",
    model: "AI Modeli",
    temperature: "Temperature",
    system_prompt: "Sistem Promptu",
    enable: "AI'ı Etkinleştir",
    save: "Kaydet",
    no_kb: "Henüz bilgi tabanı yok",
    delete: "Sil",
    title_field: "Başlık",
    content_field: "İçerik",
    url_field: "URL",
    training: "Eğitim Verisi",
  },
  analytics: {
    title: "Analitik",
    period_7: "Son 7 Gün",
    period_30: "Son 30 Gün",
    period_90: "Son 90 Gün",
    total: "Toplam Konuşma",
    open: "Açık",
    resolved: "Çözümlendi",
    ai_rate: "AI Çözüm Oranı",
    resolution_rate: "Çözümleme Oranı",
    agent_perf: "Agent Performansı",
    daily_volume: "Günlük Konuşma",
    agent: "Agent",
    assigned: "Atanan",
    resolved_count: "Çözümlenen",
    rate: "Oran",
    no_data: "Bu dönem için veri yok",
  },
  settings: {
    title: "Ayarlar",
    profile: "Profil",
    canned: "Hızlı Yanıtlar",
    tags: "Etiketler",
    team: "Ekip",
    bans: "IP Yasakları",
    branding: "Marka Yönetimi",
    name: "Ad Soyad",
    email: "E-posta",
    password: "Yeni Şifre",
    save: "Kaydet",
    add_canned: "Hızlı Yanıt Ekle",
    canned_title: "Başlık",
    canned_content: "İçerik",
    shortcut: "Kısayol",
    add_tag: "Etiket Ekle",
    tag_name: "Etiket Adı",
    tag_color: "Renk",
    delete: "Sil",
    select_site: "Site Seçin",
  },
  common: {
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    add: "Ekle",
    close: "Kapat",
    confirm: "Onayla",
    loading: "Yükleniyor...",
    error: "Hata oluştu",
    success: "Başarılı",
    search: "Ara...",
    no_data: "Veri bulunamadı",
    ago: "önce",
    just_now: "Az önce",
    visitor: "Ziyaretçi",
    agent: "Agent",
    bot: "AI Bot",
  }
};

export default tr;
